
<template>
    <ListDetailLayout
		    :store="deviceModelsStore"
        index-route-name="admin.devices.models"
		    create-permissions="create:device-models"
		    @on-create="$router.push({ name: 'admin.devices.models.model', params: { model: 'NEW' } })"
		    @on-paginate="(page) => useOnPaginate(page, refreshDeviceModels, params)"
		    @on-search="(page) => useOnSearch(page, refreshDeviceModels, params)"
        :filter="params.filter"
        @on-filter="({ filter }) => useOnFilter(filter, refreshDeviceModels, params)"
		create-button-admin-page="create-device-model-admin-btn"
	    search-admin-page="search-device-model-admin-page"
    >
        <template #list>
            <li v-for="model in deviceModelsStore.getDeviceModels" :key="model.id">
                <router-link :to="{ name: 'admin.devices.models.model', params: { model: model.id } }" v-slot="{isActive}">
                    <div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

                        <div class="min-w-0">
                            <div class="flex items-start gap-x-3">
                                <p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ model.name }}</p>
                            </div>

		                        <div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400">
				                        <p class="whitespace-nowrap">
					                          {{ model.device_type?.name ?? '-' }}
				                        </p>
                                <p class="whitespace-nowrap">
                                    {{ modelCompanyLabel(model) }}
                                </p>
		                        </div>
                        </div>

                    </div>
                </router-link>
            </li>
        </template>

        <template #detail>
            <router-view v-if="$route.params.model" @on-save="refreshDeviceModels" @on-delete="refreshDeviceModels"></router-view>
        </template>

    </ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import { useDeviceModelsStore } from "@/stores/deviceModels.js";
import {useOnFilter, useOnPaginate, useOnSearch} from "@/Composables/Pagination.js";

export default {
	name: "DeviceModelsIndex",
	data() {
		return {
			params: {
				include: ['deviceType', 'company', 'companies'],
        filter: {
          device_manufacturer_ids: [],
          device_type_ids: [],
        }
			}
		}
	},
	methods: {
		useOnSearch,
		useOnPaginate,
    useOnFilter,
		refreshDeviceModels(){
			return this.deviceModelsStore.indexDeviceModels(this.params);
		},
    modelCompanyLabel(model) {
      if (model.companies?.length) {
        return model.companies.map(company => company.name).join(', ');
      }

      return model.company?.name ?? this.$t('common.public');
    },
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useDeviceModelsStore)
	},
	async mounted() {
		await this.refreshDeviceModels();
	}
}
</script>
